// extracted by mini-css-extract-plugin
export default {"wrapper":"Form_wrapper__fSwAL","formWrapper":"Form_formWrapper__spv2W","InputWrapper":"Form_InputWrapper__r-RTH","FormInput":"Form_FormInput__VSExC","formBtn":"Form_formBtn__DnuwH"};